import { isBoolean, isNumber, isString, mapValues } from "lodash-es";

import { useBoardStore } from "@/store/board";
import { useSessionStore } from "@/store/session";
import { toKebabCase } from "@/utils/text/text";

import type { AnalyticsData, AnalyticsEvent } from "./types";

export function normalizeEventData(data: AnalyticsData) {
  return mapValues(withDefaults(data), process);
}

/**
 * Enrich the event data with some default properties
 * - 'board' (board type)
 * - 'daysSinceStart' (number of days since the start of the first iteration)
 */
function withDefaults(data: Partial<AnalyticsEvent>) {
  return {
    board: useBoardStore().board?.type,
    daysSinceStart: useSessionStore().fullDaysSinceStart,
    ...data,
  };
}

// formats and validates a single event datum
function process<T>(value: T): T {
  if (isNumber(value)) {
    if (!isFinite(value)) {
      throw Error(`invalid number: ${value}`);
    }
    return value;
  }
  if (isString(value)) {
    return toKebabCase(value) as T;
  }
  if (isBoolean(value) || value === null || value === undefined) {
    return value;
  }
  if (Array.isArray(value)) {
    return value.map(process) as T;
  }
  throw Error(`value of invalid type: ${JSON.stringify(value)}`);
}
